import { Component } from "@angular/core";
import { MsAdalAngular6Service } from "microsoft-adal-angular6";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import * as $ from "jquery";

//declare var jquery:any;
//declare var $ :any;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
})
@Injectable({
  providedIn: "root",
})
export class AppComponent {
  title = "sharpweb";
  userdetail: any;

  //public userAbout;
  constructor(private adalSvc: MsAdalAngular6Service) {
    // console.log(this.adalSvc.userInfo);
    // console.log(this.adalSvc.login());
    // console.log(this.adalSvc.LoggedInUserName);
    // console.log(window.location.origin);
    if (adalSvc.userInfo) {
      // console.log(this.adalSvc);
      // console.log(this.adalSvc.userInfo);
      this.userdetail = this.adalSvc.userInfo.userName;
      // console.log(this.userdetail);
      var userid = this.userdetail.split("@");
      this.userdetail = userid[0];

      //var userRefNo=$("#userRefs").val();
      //alert (userRefNo);
    } else {
      // console.log("not logged in");
    }
  }

  /*getUserInfo():Observable<any> {

     this.userdetail=this.adalSvc.userInfo;
    // console.log (this.userdetail);
    //alert(this.userdetail);
    return this.userdetail;

  }*/
  //userAbout=this.adalSvc.userInfo;
}
